<svg width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6.5" y="5.5" width="4" height="1.4" rx="0.7" fill="currentColor"/>
<rect x="1.7" y="1.7" width="13.6" height="24.6" rx="2.8" stroke="currentColor" stroke-width="1.6"/>
</svg>
